import React, { useEffect } from 'react';
import HiddenInputProps from './HiddenInput.types';

const HiddenInput = ({
  value,
  dataPointer,
  onChange: setDataIntoModel,
  name,
  dataCy = 'hiddenInput',
  invalid,
}: HiddenInputProps) => {
  useEffect(() => {
    setDataIntoModel({
      value,
      dataPointer,
    });
  }, []);
  return <input type='hidden' value={value} name={name} data-cy={dataCy} aria-invalid={invalid} />;
};

export default HiddenInput;
